import type { FC } from 'react';
import { useListParams } from 'hooks';
import { DatePicker } from 'components/common';

const FilterDate: FC = () => {
  const { date, setDate } = useListParams();
  return (
    <DatePicker maxDate={new Date()} field="date" label="Creation date" actualValue={date} setActualValue={setDate} />
  );
};

export default FilterDate;